import "./_recruitment-list-styles.scss";

 import './recruitment-list';
